export function getEmptyStateName(pathname?: string) {
    if (pathname?.includes('/analytics')) {
        return 'analytics';
    }
    if (pathname?.includes('/listening')) {
        return 'listening';
    }
    if (pathname?.includes('/campaigns')) {
        return 'content.campaigns';
    }
    if (pathname?.includes('/conversations')) {
        return 'conversations';
    }
    if (pathname?.includes('/scheduler') && !pathname?.includes('/feed-preview')) {
        return null; // This is a special case for the scheduler page, where we want to display the default empty state text for the groups
    }
    return pathname?.replace('/', '').replaceAll('/', '.');
}
